export enum ReportType {
  Sales = 'SALES',
  Orders = 'ORDERS',
}

export const actionTypes = {
  // Sales Over Time
  FETCH_SALES_OVER_TIME_LOADING: 'FETCH_SALES_OVER_TIME_LOADING',
  FETCH_SALES_OVER_TIME: 'FETCH_SALES_OVER_TIME',
  FETCH_SALES_OVER_TIME_ERROR: 'FETCH_SALES_OVER_TIME_ERROR',
  FETCH_SALES_OVER_TIME_ACTIVITY_LOADING: 'FETCH_SALES_OVER_TIME_ACTIVITY_LOADING',
  FETCH_SALES_OVER_TIME_ACTIVITY: 'FETCH_SALES_OVER_TIME_ACTIVITY',
  FETCH_SALES_OVER_TIME_ACTIVITY_ERROR: 'FETCH_SALES_OVER_TIME_ACTIVITY_ERROR',

  EXPORT_SALES_OVER_TIME_REPORT_LOADING: 'EXPORT_SALES_OVER_TIME_REPORT_LOADING',
  EXPORT_SALES_OVER_TIME_REPORT: 'EXPORT_SALES_OVER_TIME_REPORT',
  RESET_SALES_OVER_TIME_EXPORT_SUCCESS: 'RESET_SALES_OVER_TIME_EXPORT_SUCCESS',
};
